import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Computer } from 'src/app/models/computer.model';
import { ApiService } from 'src/app/services/api.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatSuffix, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-credit-computer-dialog',
  templateUrl: './credit-computer-dialog.component.html',
  styleUrl: './credit-computer-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatHint,
    MatDialogActions,
    MatButton,
    MatIcon,
  ],
})
export class CreditComputerDialogComponent implements OnInit {
  protected fb = inject(FormBuilder);
  dialogRef = inject<MatDialogRef<CreditComputerDialogComponent>>(MatDialogRef);
  data = inject<{
    computer: Computer | undefined;
  }>(MAT_DIALOG_DATA);
  private api = inject(ApiService);

  form: FormGroup;

  get isCreate() {
    return this.form.value['id'] == '';
  }

  constructor() {
    const data = this.data;

    this.form = this.fb.group({
      id: ['', Validators.compose([])],
      model: ['', Validators.compose([Validators.required, Validators.minLength(5)])],
      buyed_at: ['', Validators.compose([Validators.required])],
      ram_memory_in_gb: ['', Validators.compose([Validators.required, Validators.min(1)])],
      ssd_memory_in_gb: ['', Validators.compose([Validators.required, Validators.min(1)])],
      serial_number: ['', Validators.compose([Validators.required, Validators.minLength(5)])],
      chip: ['', Validators.compose([Validators.required, Validators.minLength(5)])],
      holded_asset_id: ['', Validators.compose([Validators.required])],
    });

    if (data.computer != undefined) {
      this.form.patchValue(data.computer);
    }
  }

  ngOnInit(): void {}

  submit() {
    if (this.isCreate) {
      this.createComputer();
    } else {
      this.updateComputer();
    }
  }

  close(data: any | undefined = undefined) {
    this.dialogRef.close(data);
  }

  private createComputer() {
    this.api.createComputer(this.form.value).subscribe(data => {
      this.close(data);
    });
  }

  private updateComputer() {
    this.api.updateComputer(this.form.value['id'], this.form.value).subscribe(data => {
      this.close(data);
    });
  }
}
